import { Injectable } from '@angular/core';
import { ApiCallHandler } from '../../modules/core/models/apiCallHandler';
import { EoHttpClient, IHttpParams } from 'ngx-eo-web-components';
import { CoreService } from '../../modules/core/core.service';
import { BehaviorSubject, Observable, firstValueFrom } from 'rxjs';
import { PaginatedSearchOptions } from '../../modules/core/models/paginated-search-options.model';
import { HospitalUser } from '../../modules/core/models/hospital-user.model';

@Injectable({
  providedIn: 'root',
})
export class HospitalUserService {
  public viewOptions$ = new BehaviorSubject<PaginatedSearchOptions>(
    new PaginatedSearchOptions()
  );
  public hospitalUserListCallHandler = new ApiCallHandler<HospitalUser[]>();

  constructor(
    private http: EoHttpClient,
    private coreService: CoreService
  ) {}

  init() {
    this.hospitalUserListCallHandler.init([]);
  }

  getHospitalUsersByHospital(hospitalId: string) {
    const param: IHttpParams = this.coreService.initCall(
      `/v1/HospitalUsers/list/${hospitalId}`,
      this.hospitalUserListCallHandler
    );

    return this.http.get<HospitalUser[]>(param);
  }

  getHospitalUsersByHospitalAndRole(hospitalId: string, role: string) {
    const param: IHttpParams = this.coreService.initCall(
      `/v1/HospitalUsers/list/${hospitalId}/${role}`,
      this.hospitalUserListCallHandler
    );

    return this.http.get<HospitalUser[]>(param);
  }

}
